export default __webpack_public_path__ + "static/media/hardrock-038-rockwool-paket-platte-recyclable_comp.1e9f1360.jpg";